<div class="container">
    <div class="section-title">
        <h2>{{'main_title_feature' | translate}}</h2>
        <div class="bar"></div>
        <p>
            {{'sub_title_feature' | translate}}
        </p>
    </div>

    <div class="row">
        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i>
                        <fa-icon [icon]="faShieldVirus" size="lg"></fa-icon>
                    </i>
                </div>
                <h3>{{'feature_1' | translate}}</h3>
                <p>
                    {{'feature1_content' | translate}}
                </p>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i>
                        <fa-icon [icon]="faLightbulb" size="lg"></fa-icon>
                    </i>
                </div>
                <h3>{{'feature_2' | translate}}</h3>
                <p>
                    {{'feature2_content' | translate}}
                </p>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i>
                        <fa-icon [icon]="faBolt" size="lg"></fa-icon>
                    </i>
                </div>
                <h3>{{'feature_3' | translate}}</h3>
                <p>
                    {{'feature3_content' | translate}}
                </p>
            </div>
        </div>
    </div>

    <div class="row row-j-c">
        <!-- <div class="flex-fill"></div> -->

        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i>
                        <fa-icon [icon]="faClockRotateLeft" size="lg"></fa-icon>
                    </i>
                </div>
                <h3>{{'feature_4' | translate}}</h3>
                <p>
                    {{'feature4_content' | translate}}
                </p>
            </div>
        </div>
        <!-- <div class="flex-fill"></div> -->

    </div>
</div>
